$(function() {
    // Plans price selector in compare table

    function selectTablePricing($element) {
        var $splittedPrice = $element.find(':selected').data('price').toString().split('.');
        var $planId = $element.find(':selected').data('plan-id');
        var $planWrapper = $('.table-price[data-plan-id=' + $planId + ']');

        $planWrapper.find('.price-part-1').text($splittedPrice[0]);
        $planWrapper.find('.price-part-2').text($splittedPrice[1]);

        var $buyButton = $('.btn-buy[data-plan-id=' + $planId + ']');

        if ($buyButton.attr('href').indexOf('billingcycle') >= 0) {
            $buyButton.attr('href', $buyButton.attr('href').substring(0, $buyButton.attr('href').indexOf('&billingcycle=')) + '&billingcycle=' + $element.find(':selected').data('period'));
        } else {
            $buyButton.attr('href', $buyButton.attr('href') + '&billingcycle=' + $element.find(':selected').data('period'));
        }
    }

    var $tablePriceSelector = $('.table-price-selector');

    $tablePriceSelector.select2({
        theme: 'windows-cloud',
        width: 'resolve',
        minimumResultsForSearch: -1
    }).on('change', function() {
        selectTablePricing($(this));
    });

    $tablePriceSelector.each(function() {
        selectTablePricing($(this));
    });
});